import { confetti } from "@tsparticles/confetti";

export const shootConfetti = () => {
  confetti({
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: [
      "#ffb400",
      "#d2980d",
      "#a57c1b",
      "#786028",
      "#363445",
      "#48446e",
      "#5e569b",
      "#776bcd",
      "#9080ff",
    ],
    shapes: ["star"],
  });
};
